import { Box, Typography, FormControl, Select, MenuItem, FormControlLabel, Switch, TextField } from '@mui/material';
import { WSPContactFields } from './WSPContactFields';
import { WSPUrlLinkFields } from './WSPUrlLinkFields';
import { WSPLocationFields } from './WSPLocationFields';

export function WSPNodeFields({ 
  localNodeData, 
  updateNodeData,
  addArrayItem,
  removeArrayItem,
  updateArrayItem,
  updateObjectField
}) {
  return (
    <Box>
      <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
        Tipo WhatsApp
      </Typography>
      <FormControl fullWidth size="small">
        <Select
          value={localNodeData.WSPObjectType || ''}
          onChange={(e) => updateNodeData('WSPObjectType', e.target.value)}
        >
          <MenuItem value="contact">Contacto</MenuItem>
          <MenuItem value="urllink">Enlace Interactivo</MenuItem>
          <MenuItem value="location">Ubicación</MenuItem>
        </Select>
      </FormControl>

      {localNodeData.WSPObjectType === 'contact' && (
        <WSPContactFields
          localNodeData={localNodeData}
          updateNodeData={updateNodeData}
          addArrayItem={addArrayItem}
          removeArrayItem={removeArrayItem}
          updateArrayItem={updateArrayItem}
          updateObjectField={updateObjectField}
        />
      )}

      {localNodeData.WSPObjectType === 'urllink' && (
        <WSPUrlLinkFields
          localNodeData={localNodeData}
          updateNodeData={updateNodeData}
        />
      )}

      {localNodeData.WSPObjectType === 'location' && (
        <WSPLocationFields
          localNodeData={localNodeData}
          updateNodeData={updateNodeData}
        />
      )}

      {/* Configuración opcional de espera de evento externo (firma, etc.) */}
      <Box sx={{ mt: 3, p: 2, borderRadius: 1, border: '1px solid rgba(0,0,0,0.12)' }}>
        <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
          Espera de evento externo (firma, callback)
        </Typography>
        <FormControlLabel
          control={
            <Switch
              size="small"
              checked={!!localNodeData.waitForExternalEvent}
              onChange={(e) => updateNodeData('waitForExternalEvent', e.target.checked)}
            />
          }
          label="Mantener flujo en espera hasta recibir callback"
        />

        {localNodeData.waitForExternalEvent && (
          <>
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
                Clave de espera (waitKey)
              </Typography>
              <TextField
                size="small"
                fullWidth
                placeholder="Ej: firma_{idDocumento} o flow_{flowId}_node_{nodeId}"
                value={localNodeData.waitKey || ''}
                onChange={(e) => updateNodeData('waitKey', e.target.value)}
              />
            </Box>

            <Box sx={{ mt: 2 }}>
              <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
                Tiempo máximo de espera (minutos)
              </Typography>
              <TextField
                size="small"
                type="number"
                fullWidth
                inputProps={{ min: 1 }}
                placeholder="Ej: 60"
                value={localNodeData.timeoutMinutes || ''}
                onChange={(e) => updateNodeData('timeoutMinutes', e.target.value)}
              />
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
}